import { useQuery } from 'react-query';

import { Partner, fetchPartners } from '../utils/backend-api/partners';

export const PARTNERS_KEY = 'PARTNERS';

export default function usePartners() {
  const { data: partners, isLoading: isLoadingPartners } = useQuery<Partner[]>(
    PARTNERS_KEY,
    async () => await fetchPartners()
  );
  return { partners, isLoadingPartners };
}
